<template>
  <default-layout>
    <section slot="content">
      <v-container fluid class="tracking-container">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="10" md="6" lg="4">
            <v-card
              class="tracking-card pa-6"
              elevation="8"
            >
              <!-- Header -->
              <div class="text-center mb-6">
                <v-avatar
                  size="80"
                  color="primary lighten-5"
                >
                  <v-icon
                    size="42"
                    color="primary"
                  >
                    mdi-truck-delivery
                  </v-icon>
                </v-avatar>

                <h1 class="tracking-title mt-4">
                  Rastrea tu pedido
                </h1>

                <p class="tracking-subtitle">
                  Ingresa tu número de pedido y el correo utilizado
                  durante la compra.
                </p>
              </div>

              <!-- Formulario -->
              <v-form
                ref="form"
                v-model="form"
              >
                <v-text-field
                  v-model="orderNumber"
                  label="Número de pedido"
                  placeholder="0001020-333"
                  prepend-inner-icon="mdi-package-variant"
                  :rules="[rules.required]"
                  outlined
                  dense
                  persistent-hint
                  hint="Lo encontrarás en el correo de confirmación."
                />

                <v-text-field
                  v-model="email"
                  label="Correo electrónico"
                  placeholder="correo@ejemplo.com"
                  prepend-inner-icon="mdi-email-outline"
                  :rules="[rules.required, rules.email]"
                  type="email"
                  outlined
                  dense
                />

                <v-btn
                  color="primary"
                  block
                  large
                  depressed
                  class="mt-4 tracking-btn"
                  :disabled="!form"
                  @click="trackOrder"
                >
                  Ver estado del pedido
                </v-btn>
              </v-form>

              <!-- Confianza -->
              <div class="security-text text-center mt-5">
                <v-icon
                  small
                  color="success"
                >
                  mdi-shield-check
                </v-icon>

                Tus datos se utilizan únicamente para consultar tu pedido.
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Snackbar -->
        <v-snackbar
          v-model="snackbar"
          :color="color"
          top
        >
          {{ message }}

          <template v-slot:action="{ attrs }">
            <v-btn
              text
              color="white"
              v-bind="attrs"
              @click="snackbar = false"
            >
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'

  export default {
    name: 'OrderTrackingLogin',
    components: {
      DefaultLayout
    },
    data () {
      return {
        orderNumber: '',
        email: '',
        form: false,
        rules: {
          email: v => /.+@.+\..+/.test(v) || 'Por favor ingresar un correo válido',
          length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
          required: v => !!v || 'Por favor completar este campo',
        },

        color: 'green',
        message: '',
        snackbar: false
      }
    },
    methods: {
      errorLogin () {
        if (this.email &&
            this.orderNumber &&
            /.+@.+\..+/.test(this.email)) {
          return false;
        }

        return true;
      },
      trackOrder () {
        if (this.errorLogin()) {
          this.snackbar = true;
          this.text = '¡Ingresar datos por favor!';
          this.color = 'red';
          return;
        }

        const request = {
          email: this.email,
          order_number: this.orderNumber
        };

        axios.post(process.env.DINO.PATH.LOGIN_FIND_ORDER_DETAIL, request)
        .then(response => {
          if (response.data.success) {
            this.color = response.data.success ? 'green' : 'red';
            this.message = response.data.message;
            this.snackbar = true;
            localStorage.setItem('orderNumber', this.orderNumber);
            this.$router.push({ name: 'OrderTrackingDetail' }).catch(err => {});
          } else {
            this.color = 'red';
            this.message = '¡No existe pedido, verificar los datos ingresados!';
            this.snackbar = true;
            localStorage.removeItem('orderNumber');
          }
        })
        .catch(err => {
          localStorage.removeItem('orderNumber');
        });
      }
    },
    mounted: function () {
      localStorage.removeItem('orderNumber');
    }
  }
</script>
<style scoped>

.tracking-container {
  min-height: calc(100vh - 100px);
  display: flex;
  align-items: center;
}

.tracking-card {
  border-radius: 24px;
  border: 1px solid #f1f5f9;
}

.tracking-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.tracking-subtitle {
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.6;
  max-width: 320px;
  margin: auto;
}

.security-text {
  font-size: 0.85rem;
  color: #6b7280;
}

.tracking-btn {
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0;
  height: 48px !important;
}

.v-text-field >>> input {
  font-size: 14px;
}

.v-text-field >>> label {
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/views/OrderTrackingLogin.vue